import { useTranslation } from 'react-i18next';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import SickIcon from '@mui/icons-material/Sick';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { AbsenceKind } from 'src/types';
import themeColors from 'src/theme/colors';

import useStyles from './BannerNote.styles';

interface Props {
  kind: AbsenceKind;
}

/** Daily-view banner marking an approved vacation or sick day as a blocked day. */
export const AbsenceBannerNote = ({ kind }: Props) => {
  const { vacationIcon, blockTimeNote, note } = useStyles();
  const { t } = useTranslation('translation', {
    keyPrefix: 'AbsenceBannerNote',
  });

  const Icon = kind === 'vacation' ? BeachAccessIcon : SickIcon;

  return (
    <Box className={clsx(note, blockTimeNote)}>
      <Icon className={vacationIcon} fontSize="inherit" />
      <Typography color={themeColors.shade4} variant="h6">
        {t(kind)}
      </Typography>
    </Box>
  );
};
